import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidStatusTransitionError extends CodedError {
  static get errorName() {
    return errorCodes.invalidStatusTransitionError.code;
  }

  constructor(message: string = errorCodes.invalidStatusTransitionError.message) {
    super(message);
    this.code = errorCodes.invalidStatusTransitionError.code;
    this.message = `${message} ${errorCodes.invalidStatusTransitionError.code}`;
    this.name = errorCodes.invalidStatusTransitionError.name;
  }
}
